import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { ORDERS_PATH } from '../../core/constants';

export const returnCustomerOrderAction = createAsyncThunk(
    'order/returnCustomerOrderAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.patch(`${ ORDERS_PATH }/${ data.orderId }/return`, data.form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const returnCustomerOrderSlice = createSlice({
    name: 'returnCustomerOrderSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(returnCustomerOrderAction.pending, () => STATE__API__STARTED);
        builder.addCase(returnCustomerOrderAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(returnCustomerOrderAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const returnCustomerOrderState = (state) => state.order.returnCustomerOrder;
export default returnCustomerOrderSlice.reducer;
